<template>
    <div class="w-screen h-screen bg-white dark:bg-logo-600 transition-colors duration-150 ease-in-out">
        <div
            v-if="isRouterReady"
            class="w-screen h-screen pt-safe pl-safe pr-safe"
        >
            <div class="w-full h-full flex flex-col pb-safe overflow-hidden">
                <RouterView v-slot="{ Component }">
                    <Component :is="layout">
                        <Component :is="Component" />
                    </Component>
                </RouterView>
            </div>

            <Toasts
                class="mx-auto inset-x-4 bottom-28 md:bottom-auto md:top-4 p-safe md:right-auto md:max-w-sm z-50"
            />

            <Notifications
                class="mx-auto inset-x-4 top-4 p-safe md:left-auto md:max-w-sm z-50"
            />
        </div>

        <SplashScreen v-else />
    </div>
</template>

<script setup>
    import { Notifications } from '/src/components/notifications';
    import { Toasts } from '/src/components/toasts';
    import SplashScreen from '/src/components/splash-screen';

    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { useLayout } from '/src/composables/useLayout';
    import { useStatusBarService } from '/src/services/useStatusbarService.js';
    import { useKeyboardService } from '/src/services/useKeyboardService.js';
    import { useHapticsService } from '/src/services/useHapticsService.js';
    import { useNetworkService } from '/src/services/useNetworkService.js';
    import { useNfcService } from '/src/services/useNfcService.js';
    import { useGeolocationService } from '/src/services/useGeolocationService.js';
    import { useClockService } from '/src/services/useClockService.js';

    // layout
    const layout = useLayout('div');

    // status bar
    const { start: startStatusBarService } = useStatusBarService();
    startStatusBarService();

    // keyboard
    const { start: startKayboardService } = useKeyboardService();
    startKayboardService();

    // haptics
    const { start: startHapticsService } = useHapticsService();
    startHapticsService();

    // network
    const { start: startNetworkService } = useNetworkService();
    startNetworkService();

    // nfc
    const { start: startNfcService } = useNfcService();
    startNfcService();

    // location
    const { start: startGeolocationService } = useGeolocationService();
    startGeolocationService();

    // offline clocks
    const { start: startClockService } = useClockService();
    startClockService();

    // splash screen
    const router = useRouter();
    const isRouterReady = ref(false);

    async function onRouterReady () {
        await router.isReady();
        isRouterReady.value = true;
    }

    onRouterReady();
</script>
